function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 12"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 1.5C15.5.675 14.825 0 14 0H2C1.175 0 .5.675.5 1.5v9c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-9zm-1.5 0L8 5.25 2 1.5h12zm0 9H2V3l6 3.75L14 3v7.5z",
  fill: "#fff"
})));